import React, { useState } from 'react'
import _ from 'lodash'

import PopupTypes from '../../../popup_types'
import { GlgPopup, GlgPopupForm, GlgRadio, ClubFeedNotificationCheckbox } from 'SharedComponents'
import { clubFeedChannelsMessage } from '../../../../shared/club_feed_channels'
import { clubFeedPopupFields } from '../../../column_helpers'

const InvitationListRegistrationPopupSimGolf = (props) => {
  const [anySelected, setAnySelected] = useState(false)
  const [formatData, setFormData] = useState()
  const [skipNotifications, setSkipNotifications] = useState(false)
  const clubFeed = clubFeedPopupFields(props.data)
  const clubFeedMessage = clubFeedChannelsMessage(clubFeed.action, clubFeed.channels, clubFeed.product)

  const onClose = () => {
    props.onClose(PopupTypes.INVITATION_LIST_REGISTRATION)
  }

  const confirmMessage = () => {
    const membershipNames = _.join(props.data.selectedDropdownOption.futureMembershipProgramsNames, ', ')
    return `${ window.I18n.t('customer_center_comp.components.popup_questions.memberships_for_future') } ${membershipNames}.\n
      ${ window.I18n.t('customer_center_comp.components.popup_questions.if_continue') }\n\n
      ${ window.I18n.t('customer_center_comp.components.popup_questions.are_you_sure') }`
  }

  const handleFormSave = () => {
    let status = formatData
    if (status === 'closed') {
      status = ''
    }

    if ( formatData === 'closed' || _.isEmpty(props.data.selectedDropdownOption.futureMembershipProgramsNames) ){
      props.onSave(props.data.selectedDropdownOption.leagueId, status, skipNotifications)
    } else {
      if ( confirm(confirmMessage()) ) { // eslint-disable-line no-alert
        props.onSave(props.data.selectedDropdownOption.leagueId, status, skipNotifications)
      }
    }
  }

  const handleOptionChange = () => {
    setAnySelected(true)
  }

  return (
    <GlgPopup
      title={ window.I18n.t('customer_center_comp.components.sim_golf_labels.change_registration_to') }
      show={ props.show }
      onClose={ onClose }
      onSave={ handleFormSave }
      saveButtonEnabled={ anySelected }
    >
      <GlgPopupForm>
        {(props.data.selectedDropdownOption && props.data.selectedDropdownOption.openRegistrationStatus !== 'invitation_list') && props.data.selectedDropdownOption.canInvitationsList && (
          <GlgRadio
            name="toggle_value"
            value="invitation_list"
            label={ window.I18n.t('customer_center_comp.components.sim_golf_labels.open_for_invitation_list') }
            defaultChecked={ false }
            onChange={(val) => {
              setFormData(val)
              handleOptionChange()
            }}
          />
        )}
        {props.data.selectedDropdownOption && props.data.selectedDropdownOption.openRegistrationStatus !== '' && (
          <GlgRadio
            name="toggle_value"
            value="closed"
            label={ window.I18n.t('customer_center_comp.components.sim_golf_labels.closed_for_everyone') }
            defaultChecked={ false }
            onChange={(val) => {
              setFormData(val)
              handleOptionChange()
            }}
          />
        )}
        {props.data.selectedDropdownOption && props.data.selectedDropdownOption.openRegistrationStatus !== 'open' && (
          <GlgRadio
            name="toggle_value"
            value="open"
            label={ window.I18n.t('customer_center_comp.components.sim_golf_labels.open_for_everyone') }
            defaultChecked={ false }
            onChange={(val) => {
              setFormData(val)
              handleOptionChange()
            }}
          />
        )}
        {props.data.selectedDropdownOption && props.data.selectedDropdownOption.canUseMembershipPrograms && (
          <div className='add-margin-bottom-10'>
            <a
              href={ props.data.selectedDropdownOption && props.data.selectedDropdownOption.registrationDatesURL }
              target={'_blank'}
              onClick={ onClose }
            >
              { window.I18n.t('customer_center_comp.components.sim_golf_labels.view_by_membership') }
            </a>
          </div>
        )}
        { clubFeedMessage && <p className='club_feed_popup_message'>{ clubFeedMessage }</p> }
        <ClubFeedNotificationCheckbox
          channels={ props.data.selectedDropdownOption && props.data.selectedDropdownOption.clubFeedChannels }
          settingsUrl={ props.data.selectedDropdownOption && props.data.selectedDropdownOption.clubFeedSettingsUrl }
          learnMoreUrl={ props.data.selectedDropdownOption && props.data.selectedDropdownOption.clubFeedLearnMoreUrl }
          checked={ skipNotifications }
          onChange={ setSkipNotifications }
        />
      </GlgPopupForm>
    </GlgPopup>
  )
}

export default InvitationListRegistrationPopupSimGolf